export function byteToMb(byte: number): number {
  return byte / 1048576;
}
